import { render, staticRenderFns } from "./StorageOrderEdit.vue?vue&type=template&id=2c632c93&"
import script from "./StorageOrderEdit.vue?vue&type=script&lang=js&"
export * from "./StorageOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports